var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.6 7.2C3.6 4.879 5.479 3 7.8 3S12 4.879 12 7.2s-1.879 4.2-4.2 4.2a4.2 4.2 0 0 1-4.2-4.2M1.2 19.8a6.6 6.6 0 0 1 13.2 0v.225c0 .87-.705 1.575-1.575 1.575H2.775c-.87 0-1.575-.705-1.575-1.575zm16.2-15a3.6 3.6 0 0 1 0 7.2 3.6 3.6 0 0 1 0-7.2m0 9c2.981 0 5.4 2.419 5.4 5.4v.84c0 .863-.698 1.56-1.56 1.56h-5.43c.248-.469.39-1.005.39-1.575V19.8a8.38 8.38 0 0 0-1.744-5.126A5.4 5.4 0 0 1 17.4 13.8"
})));
export default SvgUsers;